

















import Vue from "vue";
import Scroll from "@/utilities/Scroll";

export default Vue.extend({
  data: () => ({
    scroll: new Scroll("alcyon_logo")
  })
});
